
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateLeadFromReservationdDtoFormGroup() {
return new FormGroup({
    contactId: new FormControl<number | undefined>(undefined, [Validators.required]),
    reservationId: new FormControl<number | undefined>(undefined, [Validators.required]),
    sendConfirmationEmail: new FormControl<boolean | undefined>(false),
})
;
}
      